import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
// import LandingView from '../views/LandingView.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: () => import('../views/HomeView.vue')
  },
  {
    path: '/:sub_domain',
    name: 'template',
    props: true,
    component: () => import('../views/LandPage1.vue')
  },
  {
    path: '/privacy/policy',
    name: 'template',
    props: true,
    component: () => import('../views/PriView.vue')
  },
  {
    path: '/contact/us',
    name: 'Contact',
    props: true,
    component: () => import('../views/ContactView.vue')
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})
router.beforeEach((to, from, next) => {
  const token = store.state.token

  if (to.meta.requiresAuth && !token) {
    console.log('No token found, redirecting to /login')
    next('/login')
  } else {
    next()
  }
  if (token && to.path === '/login') {
    next('/')
  } else {
    next()
  }
})
export default router
